var r = /* @__PURE__ */ ((c) => (c.Rect = "rect", c.Circle = "circle", c.Text = "text", c))(r || {});
const t = ["rect", "circle", "text"];
export {
  t as SKELETON_MODES,
  r as SkeletonMode
};
